import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { UserService } from "@career/core/services/user.service";
import { map, take } from "rxjs/operators";
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class AdminAuthGaurd implements CanActivate {
  constructor(
    private router: Router,
    private userSvc : UserService
  ) {}

  canActivate() {
    return forkJoin([this.userSvc.getUser(true).pipe(take(1)), this.userSvc.isAdmin().pipe(take(1))]).pipe(
      map(([user, isAdmin]) => {
        if (user && isAdmin) {
          return true;
        }
        this.router.navigate(["/"]);
        return false;
      })
    );
  }
}
